<template>
  <div id="app" class="site-shell">
    <header class="site-header">
      <div class="brand">
        <span class="brand-cn">ZOCEL LLC</span>
        <span class="brand-en">Registered in Kentucky, USA · Reg. No. 1625145.06</span>
      </div>
      <nav class="site-nav">
        <router-link to="/" exact>首页</router-link>
        <router-link to="/about">关于我们</router-link>
      </nav>
    </header>
    <main class="site-main">
      <router-view />
    </main>
    <footer class="site-footer">
      <div class="footer-info">
        <span class="footer-name">© 2026 ZOCEL LLC. All rights reserved.</span>
        <span class="footer-meta">企业注册号 / Registration No.：1625145.06</span>
        <span class="footer-meta">注册地址 / Registered Address：1305 Griffin St Unit A, London, KY 40741</span>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
